/**
 * Authentication Service
 * RoofMapper v3 - JWT + Google OAuth
 */

import { apiClient } from './api';
import {
  User,
  LoginCredentials,
  RegisterData,
  AuthResponse,
  SessionResponse,
} from '../types/auth';

export const authService = {
  /**
   * Login with username and password
   */
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>(
      '/api/auth/login',
      credentials
    );
    return data;
  },

  /**
   * Login with Google OAuth
   */
  async loginWithGoogle(credential: string): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>(
      '/api/auth/google-login',
      { credential }
    );
    return data;
  },

  /**
   * Check current session
   */
  async checkSession(): Promise<User> {
    const { data } = await apiClient.get<SessionResponse>('/api/auth/session');
    return data.user;
  },

  /**
   * Register new user (admin only)
   */
  async register(userData: RegisterData): Promise<User> {
    const { data } = await apiClient.post<User>('/api/auth/register', userData);
    return data;
  },

  /**
   * Get all users (admin only)
   */
  async getUsers(): Promise<User[]> {
    const { data } = await apiClient.get<User[]>('/api/auth/users');
    return data;
  },

  /**
   * Delete user (admin only)
   */
  async deleteUser(username: string): Promise<void> {
    await apiClient.delete(`/api/auth/users/${username}`);
  },

  /**
   * Logout (client-side only)
   */
  logout(): void {
    localStorage.removeItem('authToken');
  },
};

export default authService;
